<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import CurrentList from './CurrentList.vue'
import ListSaveContent from './ListSaveContent.vue'
import SaveElemental from './SaveElemental.vue'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import {
  Drawer, DrawerContent, DrawerHeader, DrawerTrigger,
} from '@/components/ui/drawer'
import type { Elemental, ElementalTypeEnum } from '~~/src/types/elemental'

defineProps<Props>()
defineOptions({
  name: 'SaveElementalMenuItem',
})

interface Props {
  elemental: Elemental
  elementalType?: ElementalTypeEnum | null
  listId?: string
  isSaved?: boolean
  feedView?: boolean
}
const user = useUser()
const router = useRouter()
const [open, toggle] = useToggle()
const [showCreate, toggleShowCreate] = useToggle()

const onToggle = (value?: boolean) => {
  if (!user.value && value) {
    const path = useGetLoginURL()
    router.push(path)
    return
  }
  toggle(value)
  if (!value)
    toggleShowCreate(false)
}
useEventListener('keydown', (event) => {
  if (!open.value)
    return
  if (event.key === 'Escape')
    onToggle(false)
})

const { md, lg } = useBreakpoints(breakpointsTailwind)

defineExpose({
  open,
  toggle,
})
</script>

<template>
  <Drawer :open="open && !lg && !md" @update:open="onToggle">
    <DropdownMenu :open="open && (lg || md)" @update:open="onToggle">
      <DrawerTrigger as-child>
        <DropdownMenuTrigger as-child>
          <SaveElemental
            :elemental="elemental"
            :elemental-type="elementalType"
            :class="$attrs.class"
            :feed-view="feedView"
            :save-only="true"
            @click.prevent.stop
          >
            <template #count>
              <slot name="count" />
            </template>
          </SaveElemental>
        </DropdownMenuTrigger>
      </DrawerTrigger>
      <DropdownMenuContent class="flex flex-col gap-2 w-xs py-4">
        <CurrentList v-if="elemental" :element="elemental" :type="elementalType" />
        <DropdownMenuSeparator />
        <ListSaveContent :elemental="elemental" :type="elementalType" :show-create="showCreate" @toggle-show-create="toggleShowCreate" />
      </DropdownMenuContent>
    </DropdownMenu>
    <DrawerContent v-if="elemental && elementalType && !lg && !md" class="bottom-[90px]">
      <DrawerHeader>
        <CurrentList :element="elemental" :type="elementalType" />
      </DrawerHeader>
      <ListSaveContent :elemental="elemental" :type="elementalType" :show-create="showCreate" @toggle-show-create="toggleShowCreate" />
    </DrawerContent>
  </Drawer>
</template>
